import { UploadIcon } from "lucide-react";

import { CommandMenu, useCommandMenu } from "@/components/CommandMenu";
import { CommandGroup, CommandItem } from "@/components/ui/command";
import { useWorkspace } from "./WorkspaceProvider";

export function WorkspaceActions() {
  const { setUpdateProcess } = useWorkspace();
  const { page, setPages, setOpen } = useCommandMenu();

  return (
    <CommandMenu>
      {!page && (
        <CommandGroup heading="Test run">
          <CommandItem
            onSelect={() => {
              setOpen(false);
              setUpdateProcess(true);
            }}
          >
            <UploadIcon />
            Update process
          </CommandItem>
        </CommandGroup>
      )}
    </CommandMenu>
  );
}
